import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], total:0 ,  error: "", message: "" }


export const getChallengHistorygeAction = createAsyncThunk(
    'challenge-history',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/challengeHistory/${data?.challenge_id}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getChallengeHistorySlice = createSlice({
    name: 'challenge-history',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getChallengHistorygeAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getChallengHistorygeAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.count
            })
            builder.addCase(getChallengHistorygeAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getChallengeHistoryReducer = getChallengeHistorySlice.reducer    